import { ANALYTICS_EVENT_SEND } from '@disco/constants/ActionTypes'
import { MIXPANEL } from '@disco/constants/AnalyticsEventTypes'
/**
 * Sends an analytics event with the specified type and event name.
 * @param type - The type of analytics provider (e.g., MIXPANEL)
 * @param event - The event name to track
 * @param props - Optional properties to include with the event
 * @returns Action object with type and meta data for the analytics event
 */
export const sendAnalyticsEvent = (
  type: string,
  event: string,
  props?: Record<string, string>,
) => ({
  type: ANALYTICS_EVENT_SEND,
  meta: {
    [type]: {
      event: event,
      props: props,
    },
  },
})
/**
 * Sends a Mixpanel analytics event.
 * @param event - The event name to track in Mixpanel
 * @param props - Optional properties to include with the event
 * @returns Action object for Mixpanel event tracking
 */
export const sendMixpanelEvent = (
  event: string,
  props?: Record<string, any>,
) => {
  return sendAnalyticsEvent(MIXPANEL, event, props)
}
